import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext";

function PageTitle() {
    const { user } = useAuth();

    return (
        <>
            <div className="page-title dashboard">
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <div className="page-title-content">
                                <p>Welcome Back,
                                <span> {user?.user_name || user?.email?.split('@')[0]}</span>
                                </p>
                            </div>
                        </div>
                        <div className="col-6">
                            <ul className="text-end breadcrumbs list-unstyle">
                                <li><Link to={"./settings"}>Settings </Link></li>
                                <li className="active"><Link to={"#"}>Security</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PageTitle;